import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import { batchRequest } from '../../../../../api/ApiService';
import Teams from '../../../../../api/Teams';
import { Loader } from 'react-loaders';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from 'recharts';

class MarketShareStep19 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      marketShare: 0,
      totalUnitsSold: 0,
      otherTeamsUnitsSold: 0,
      otherTeamsUnitsSoldPercent: 0,
      teamUnits: 0,
      teamUnitsPercent: 0,
    };
  }

  componentDidMount() {
    const { activeRound } = this.props;
    const currentTeam = Teams.currentTeam();
    const teamId = Number(currentTeam.id);

    batchRequest([
      `${process.env.REACT_APP_API_URL}competition/metrics/?round_number=${activeRound}`,
      `${process.env.REACT_APP_API_URL}v2/games/targets/`,
      `${process.env.REACT_APP_API_URL}team/inventory_balances/?round_number=${activeRound}`,
    ])
      .then(res => {
        const metrics = res[0].body;
        const targets = res[1].body;
        const target = targets.find(i => i.round_number === activeRound);

        const totalUnitsSold = metrics
          .map(i => Math.abs(Number(i['Units Sold'] || 0)))
          .reduce((prev, curr) => prev + curr, 0);
        const otherTeamsUnitsSold = metrics
          .filter(i => Number(i.team) !== teamId)
          .map(i => Math.abs(Number(i['Units Sold'] || 0)))
          .reduce((prev, curr) => prev + curr, 0);
        const inventoryBalances = res[2].body;
        const teamUnits = inventoryBalances
          .map(i => Math.abs(Number(i.available_for_sale || 0)))
          .reduce((prev, curr) => prev + curr, 0);

        const otherTeamsUnitsSoldPercent = Number((otherTeamsUnitsSold / (otherTeamsUnitsSold + teamUnits) * 100).toFixed(2));
        const teamUnitsPercent = Number((100 - otherTeamsUnitsSoldPercent).toFixed(2));

        this.setState({
          loaded: true,
          marketShare: target ? Number(target.market_share || 0) : 0,
          totalUnitsSold,
          otherTeamsUnitsSold,
          otherTeamsUnitsSoldPercent,
          teamUnits,
          teamUnitsPercent,
        })
      })
      .catch(err => { });
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  renderLabel = (props) => {
    const {
      cx, cy, midAngle, outerRadius, value, name, index, payload,
    } = props;
    const { originalValue } = payload;
    const { totalUnitsSold } = this.state;
    const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 35;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
      <g>
        {index === 0 && (
          <text
            x={cx}
            y={cy}
            dy={0}
            textAnchor="middle"
            className="chartCenterLabel"
          >Total Units</text>
        )}
        {index === 0 && (
          <text
            x={cx}
            y={cy}
            dy={20}
            textAnchor="middle"
            className="chartCenterLabel"
          >{Number((totalUnitsSold / 1000000).toFixed(2))}M</text>
        )}
        <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke="rgba(0, 27, 59, 0.94)" fill="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 20}
          y={ey}
          dy={-10}
          textAnchor={textAnchor}
          className="chartLabel"
        >{`${value}%`}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 20}
          y={ey}
          dy={10}
          textAnchor={textAnchor}
          className="chartDescription1"
        >{this.numberWithCommas(originalValue)}</text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 20}
          y={ey}
          dy={32}
          textAnchor={textAnchor}
          className="chartDescription2"
        >{name}</text>
      </g>
    );
  }

  render() {
    const {
      loaded,
      marketShare,
      otherTeamsUnitsSold,
      otherTeamsUnitsSoldPercent,
      teamUnits,
      teamUnitsPercent,
    } = this.state;
    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="MARKET SHARE"
        previousShownErrors={previousShownErrors}
        alertText="Supply Issue : you didn't produce enough to hit your market share target."
        paragraph2={(
          <Fragment>
            Your company’s goal was to capture <b>{Number((marketShare * 100).toFixed(2))}%</b> of total unit sold within your competition.
            However, the total inventory that Operations had available for sale accounted
            for <b>{teamUnitsPercent}%</b> of all units sold.
          </Fragment>
        )}
        visual={(
          <ResponsiveContainer width="100%" height={320}>
            <PieChart>
              <Pie
                data={[
                  { name: 'Units sold (other teams)', originalValue: otherTeamsUnitsSold, value: otherTeamsUnitsSoldPercent },
                  { name: 'Team\'s units available for sale', originalValue: teamUnits, value: teamUnitsPercent }
                ]}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={90}
                fill="#8884d8"
                dataKey="value"
                label={this.renderLabel}
                labelLine={false}
                startAngle={90}
                endAngle={450}
              >
                ${['#52c5cd', '#f9c151'].map((color, index) => (
                  <Cell key={`pie-cell-${index}`} fill={color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        )}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default MarketShareStep19;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step19.js